import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n      transform: translate(-50%, -50%) scale(0.8);\n    "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n    "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n    width: 24px;\n    height: 24px;\n  "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    width: 32px;\n    height: 32px;\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    height: 36px;\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    margin-top: 6px\n    width: 36px;\n    height: 36px;\n    font-size: 13px;\n    line-height: 13px;\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 10px\n  font-size: 18px;\n  line-height: 18px;\n  width: 56px;\n  height: 56px;\n  position: relative;\n  transition: color 0.4s;\n  background: #ffffff;\n  border-radius: 50%;\n  color: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  ", "\n  ", "\n  ", "\n  ", "\n  svg {\n    opacity: ", ";\n    transition: 0.4s;\n    ", "\n    ", "\n    path {\n      transition: 0.4s;\n      stroke: ", ";\n    }\n  }\n  &:hover {\n    cursor: pointer;\n    &:before {\n      width: 100%;\n    }\n    color: ", ";\n    svg {\n      opacity: 1;\n      path {\n        stroke: ", ";\n      }\n    }\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    padding: 0;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    padding: 0 2px;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { media, styled } from "@styles";
import { baseFontColor, graySemi } from "@temp/@next/globalStyles/constants";
export var Wrapper = styled.div(_templateObject(), media.xxLargeScreen(_templateObject2()), media.xLargeScreen(_templateObject3()));
export var Button = styled.button(_templateObject4(), function (props) {
  return props.active ? baseFontColor : graySemi;
}, media.xxLargeScreen(_templateObject5()), media.xLargeScreen(_templateObject6()), media.mediumScreen(_templateObject7()), media.smallScreen(_templateObject8()), function (props) {
  return props.active ? 1 : 0.5;
}, media.xLargeScreen(_templateObject9()), media.mediumScreen(_templateObject10()), function (props) {
  return props.active ? baseFontColor : graySemi;
}, baseFontColor, baseFontColor);